import { useEffect } from "react";

const EVENT_KEY = "OnStorageChanged";

export function dispatchUseListenStorageEvent(storage, key, value) {
  window.dispatchEvent(
    new CustomEvent(EVENT_KEY, {
      detail: { key, value },
    }),
  );
}

const useListenStorage = (key, callback, deps = [], storage = localStorage) => {
  useEffect(() => {
    if (typeof storage.setItem !== "function") {
      throw new Error(
        "Storage setItem is not a function. Please use localStorage or sessionStorage.",
      );
    }

    const handler = (event) => {
      const { key: changedKey, value } = event?.detail || {};
      if (changedKey !== key) return;
      callback(value ?? null);
    };

    window.addEventListener(EVENT_KEY, handler);
    return () => window.removeEventListener(EVENT_KEY, handler);
  }, [key, callback, ...deps]);
};

export default useListenStorage;
